module.exports = __webpack_public_path__ + "img/icon-youtube.da4b9c32.svg";